import { BookingCalendarProvider } from "../../context/BookingCalendarContext";
import { useParams } from "react-router-dom";
import { useBookingCalendar } from "../../hooks/useBookingCalendar";
import styles from "./styles.module.css";
import { CalendarHeader } from "./CalendarHeader";
import { CalendarContent } from "./CalendarContent";

type CalendarPreviewParams = {
  gymId: string;
};

export const CalendarPreview = () => {
  const { gymId } = useParams<CalendarPreviewParams>();
  const { bookingCalendarData } = useBookingCalendar(gymId || "");

  return (
    <BookingCalendarProvider value={bookingCalendarData}>
      <main className={styles.container}>
        <CalendarHeader />
        <CalendarContent />
      </main>
    </BookingCalendarProvider>
  );
};
